<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i
													class="nav-icon fas fa-handshake"
												></i
												>&nbsp;&nbsp;Reservation&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">
										&nbsp;&nbsp;Tour Itineraries&nbsp;&nbsp;
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 pt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row mb-1 d-flex p-2">
									<div class="col-md-3 d-none">
										<div class="mb-1">
											<label for="to" class="form-label">Tour Start Date</label>
											<v-date-input
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												prepend-icon=""
												prepend-inner-icon="mdi-calendar"
												placeholder="Start Date"
												reactive
												v-model="filterItineraries.start"
												id="start"
											></v-date-input>
										</div>
									</div>
									<div class="col-md-3 d-none">
										<div class="mb-1">
											<label for="to" class="form-label">Tour End Date</label>
											<!-- v-model="filterTours.end" -->
											<v-date-input
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												prepend-icon=""
												prepend-inner-icon="mdi-calendar"
												placeholder="End Date"
												reactive
												v-model="filterItineraries.end"
												id="end"
											></v-date-input>
										</div>
									</div>
									<div class="col-md-9">
										<div class="mb-1">
											<label for="agent_id" class="form-label"
												>Registered Tour</label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												placeholder="Select Registerd Tour"
												:items="this.infiniteTours.data"
												v-model="filterItineraries.tour"
												:item-title="tourSelect"
												item-value="id"
												clearable
											>
											</v-autocomplete>
										</div>
									</div>
									<div
										class="col-md-3 d-flex justify-content-start align-items-center gap-2"
										style="font-family: HeaderCustomFont"
									>
										<button
											type="submit"
											id="Filter"
											class="btn btn-info rounded-0 text-white"
										>
											<i class="nav-icon fas fa-filter"></i>&nbsp;&nbsp;Filter
										</button>
										<button
											type="button"
											id="Export"
											class="btn btn-danger rounded-0 text-white"
										>
											<i class="nav-icon fas fa-window-close"></i
											>&nbsp;&nbsp;Clear
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row col-sm-12">
									<div class="col-sm-7 float-sm-left text-start"></div>
									<div
										class="col-sm-5 text-end"
										style="font-family: HeaderCustomFont"
									>
										<!-- @click="openModal(modal, data)" -->
										<button
											class="btn btn-info float-sm-right text-white rounded-0 d-none"
											@click="openModal('tours', 'insert')"
										>
											<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;New
											Itinerary
										</button>
									</div>
								</div>
								<div class="row col-sm-12 mt-2">
									<div class="table-responsive p-2">
										<v-text-field
											v-model="searchItinerary"
											label="Search Itineraries"
											prepend-inner-icon="mdi-magnify"
											flat
											rounded="0"
											variant="outlined"
											density="compact"
											class=""
										></v-text-field>
										<v-data-table
											v-model:items-per-page="itineraryPerPage"
											:headers="itineraryHeaders"
											:items="itineraries"
											:search="searchItinerary"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 text-truncate table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr v-for="(item, index) in items" :key="item.name">
													<td>{{ index + 1 }}</td>
													<td>{{ item.day }}</td>
													<td>{{ item.title }}</td>
													<td>{{ item.destination }}</td>
													<td>{{ item.activity }}</td>
													Accommodation
													<td class="d-none">
														<v-icon large @click="deleteRecord(item)">
															mdi-access-point-remove
														</v-icon>

														<v-icon large @click="editRecord(item)">
															mdi-pencil
														</v-icon>

														<v-icon large @click="displayReport(item)">
															mdi-file-document
														</v-icon>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</content>
</template>

<script>
import config from "../../config/settings.js";
import { Errors, Form } from "vform";

export default {
	components: {},
	data() {
		return {
			api: config.API_URL,
			message: "",
			http_code: "",
			user: [],
			infiniteTours: [],
			filterItineraries: new Form({
				start: null,
				end: null,
				tour: null,
			}),
			searchItinerary: "",
			itineraryPerPage: 10,
			itineraries: [],
			itineraryHeaders: [
				{ title: "#", value: "actions", sortable: true },
				{ title: "Title", value: "title", sortable: true },
				{ title: "Day", value: "day_number", sortable: true },
				{ title: "Destination", value: "destination", sortable: true },
				{ title: "Activity", value: "activity", sortable: true },
				{ title: "Accomodation", value: "accomodation", sortable: true },
				{ title: "Actions", value: "actions", sortable: true },
			],
			openPanels: {
				tourItinerary: [0],
				filterItinerary: [0],
			},
			tourItinerary: new Form({
				id: "",
			}),
		};
	},
	methods: {
		async checkLogin() {
			var user_id = localStorage.getItem("user_id");
			var auth = localStorage.getItem("auth");

			if (auth == null || user_id == null) {
				this.$router.push("/");
				this.logout();
				this.$swal({
					text: "Session time out",
					icon: "error",
					position: "bottom-end",
					background: "#E74C3C",
					timer: 7500,
				});
			} else {
				let api = this.api + "/check";
				const query = await this.getData(api);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					// perform other actions
					if (user_id !== null && auth !== null) {
						this.$router.push("/dash");
					}
				}

				if (query.result == "fail") {
					this.message = query.response.message;
					this.http_code = query.code;
					if (this.http_code == 503) {
						this.$swal({
							text: "Error " + this.http_code + ": " + this.message,
							icon: "error",
							position: "bottom-end",
							background: "#E74C3C",
						});
					}

					localStorage.clear();
					sessionStorage.clear();
				}
			}
		},
		async authUser() {
			var user_id = localStorage.getItem("user_id");
			var auth = localStorage.getItem("auth");

			if (user_id !== null && auth !== null) {
				var api = this.api + "/user/" + user_id;
				const query = await this.getData(api);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.user = query.response.data;
					this.user_department = this.user.Department_id;
					localStorage.setItem("user_department", this.user.Department_id);
					localStorage.setItem("user_directorate", this.user.Directorate_id);
					localStorage.setItem(
						"selected_directorate",
						this.user.Directorate_id
					);
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
					this.$swal({
						text: "Error " + this.http_code + ": " + this.message,
						icon: "error",
						position: "bottom-end",
						background: "#E74C3C",
						timer: 7500,
					});
					this.$router.push("/");
				}
			}
		},
		async getInfinites(mode) {
			var query, api;
			if (mode == "tours") {
				api = this.api + "/tours";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTours = [];
					this.infiniteTours = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
		async manageItinerary(event, mode) {
			var query, api;
			if (mode == "fetch") {
				let api = this.api + "/itinerary";
				const query = await this.getData(api);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					// perform other actions
				}
			} else if (mode == "post") {
				let api = this.api + "/itinerary";
				const query = await this.postData(api, this.tourItinerary);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					// perform other actions
				}
			} else if (mode == "update") {
				let api = this.api + "/itinerary/" + event.id;
				const query = await this.putData(api, this.tourItinerary);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					// perform other actions
				}
			} else {
				let api = this.api + "/itinerary/" + event.id;
				const query = await this.deleteData(api);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					// perform other actions
				}
			}
		},
	},
	computed: {
		tourSelect() {
			return (item) => {
				if (item && item.reference_number && item.client && item.agent_name) {
					return (
						item.reference_number + " (" + item.client + ") " + item.agent_name
					);
				}
				// return ""; // Handle cases where fields are missing
			};
		},
		truncateTitle() {
			return {
				contentClass: "truncate-title",
			};
		},
	},
	created() {
		this.getInfinites("tours");
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {},
};
</script>




